const risks = [
  {
    icon: 'ri-money-dollar-circle-line',
    title: 'Gastos imprevistos',
    desc: 'Un servicio funerario puede representar un gasto fuerte y urgente. Sin prevision, la familia resuelve en el peor momento.',
  },
  {
    icon: 'ri-time-line',
    title: 'Decisiones bajo presion',
    desc: 'Cuando todo ocurre rapido, comparar opciones, coordinar y pagar se vuelve mucho mas pesado.',
  },
  {
    icon: 'ri-heart-pulse-line',
    title: 'Carga emocional',
    desc: 'Ademas del duelo, la familia puede cargar con tramites, llamadas y decisiones que pudieron anticiparse.',
  },
];

export default function BenefitStrip() {
  return (
    <section className="bg-white py-14 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-3xl text-center">
          <span className="inline-flex rounded-full border border-[#DDD8F5] bg-[#F7F6FF] px-4 py-2 text-xs font-black uppercase tracking-wide text-[#534AB7]">
            La realidad
          </span>
          <h2 className="mt-5 font-title text-3xl font-black leading-tight tracking-[-0.035em] text-[#171421] md:text-5xl">
            Cuando una familia no esta preparada, decide bajo presion
          </h2>
          <p className="mt-5 text-base leading-8 text-[#625D70] md:text-lg">
            Coverly no intenta asustar. Pone orden antes de que exista una urgencia, para que tu familia no tenga que improvisar.
          </p>
        </div>

        <div className="mt-10 grid gap-4 md:grid-cols-3">
          {risks.map((risk) => (
            <article key={risk.title} className="rounded-[28px] border border-[#E8E4F8] bg-[#FBFAFF] p-6">
              <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-[#534AB7] text-white">
                <i className={`${risk.icon} text-xl`} />
              </div>
              <h3 className="mt-5 text-xl font-black text-[#242033]">{risk.title}</h3>
              <p className="mt-3 text-sm leading-7 text-[#6B6578]">{risk.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
